module.exports = __webpack_public_path__ + "img/ic_search.99ebd8c8.svg";